export default "__VITE_ASSET__ytP3S0Py__"